import * as React from 'react';
import { Translate } from '../../../../shared/LanguageService';
import { FormControl, ControlLabel, Checkbox, Row, Col } from 'react-bootstrap';
import { IInvoiceReceiver, INamedIdentity } from '../../Entities';
import FormSelect from '../../../../components/common/FormSelect';
import ValidatableFormGroup from '../../../../components/common/ValidatableFormGroup';
import { InvoiceSellerStatus, InvoiceReceiverTypes } from '../../Entities';

interface ICreateOrderInvoiceReceiverFormProps {
    invoiceSellerStatus: InvoiceSellerStatus;
    invoiceReceiver: IInvoiceReceiver;
    isCommercial: boolean;
    isPackageOrder: boolean;
    onDataChange: (e: any) => void;
    onInvoiceReceiverReceiverChange: (e: any) => void;
    onInvoiceBillingMethodChange: (e: any) => void;
    onInvoiceReceiverOtherBrokerFirmChange: (e: any) => void;
    isFormValid: () => boolean;
    errors: any;
    availablePrivateInvoiceReceiverTypes: INamedIdentity[];
    availableCommercialInvoiceReceiverTypes: INamedIdentity[];
    availableInvoiceBillingMethods: INamedIdentity[];
    availableOtherToInvoice: any[];
    openAgreementModal: () => void;
}

const CreateOrderInvoiceReceiverForm = (props: ICreateOrderInvoiceReceiverFormProps) => {
    return (
        <form>
            <fieldset>
                <legend>{Translate('orders/create/form/header/invoice-receiver')}</legend>
                {props.isCommercial && (
                    <ValidatableFormGroup
                        validationKey="invoiceReceiver.ProjectNumber"
                        errors={props.errors}
                    >
                        <ControlLabel>
                            {Translate(
                                'orders/create/form/input-label/invoice-receiver-project-number'
                            )}
                        </ControlLabel>
                        <FormControl
                            type="text"
                            name="invoiceReceiver.projectNumber"
                            value={
                                props.invoiceReceiver.projectNumber
                                    ? props.invoiceReceiver.projectNumber
                                    : ''
                            }
                            onChange={props.onDataChange}
                        />
                    </ValidatableFormGroup>
                )}
                <ValidatableFormGroup
                    required
                    validationKey="invoiceReceiver.Receiver"
                    errors={props.errors}
                >
                    <ControlLabel>
                        {Translate('orders/create/form/input-label/invoice-receiver-receiver')}
                    </ControlLabel>

                    <FormSelect
                        name="invoiceReceiver.receiver"
                        value={
                            props.invoiceSellerStatus === InvoiceSellerStatus.Mandatory
                                ? InvoiceReceiverTypes.Seller
                                : props.invoiceReceiver.receiver
                                ? props.invoiceReceiver.receiver.toString()
                                : ''
                        }
                        onChange={props.onInvoiceReceiverReceiverChange}
                    >
                        {props.invoiceSellerStatus === InvoiceSellerStatus.Mandatory
                            ? props.availablePrivateInvoiceReceiverTypes
                                  .filter((x: any) => x.id === InvoiceReceiverTypes.Seller)
                                  .map((x: any) => (
                                      <option value={x.id} key={x.id}>
                                          {Translate(x.name)}
                                      </option>
                                  ))
                            : props.isCommercial
                            ? props.availableCommercialInvoiceReceiverTypes
                                  .filter(
                                      (x: any) =>
                                          x.id !== InvoiceReceiverTypes.OtherCompany ||
                                          props.availableOtherToInvoice.length > 0
                                  )
                                  .map((x: any) => (
                                      <option value={x.id} key={x.id}>
                                          {Translate(x.name)}
                                      </option>
                                  ))
                            : props.availablePrivateInvoiceReceiverTypes
                                  .filter(
                                      (x: any) =>
                                          x.id !== InvoiceReceiverTypes.OtherCompany ||
                                          props.availableOtherToInvoice.length > 0
                                  )
                                  .map((x: any) => (
                                      <option value={x.id} key={x.id}>
                                          {Translate(x.name)}
                                      </option>
                                  ))}
                    </FormSelect>
                </ValidatableFormGroup>
                {props.invoiceReceiver.receiver === InvoiceReceiverTypes.OtherCompany && (
                    <ValidatableFormGroup
                        required
                        validationKey="invoiceReceiver.OtherBrokerFirm"
                        errors={props.errors}
                    >
                        <ControlLabel>
                            {Translate(
                                'orders/create/form/input-label/invoice-receiver-other-broker-firm'
                            )}
                        </ControlLabel>
                        <FormSelect
                            name="invoiceReceiver.otherBrokerFirm"
                            value={
                                props.invoiceReceiver.otherBrokerFirm
                                    ? props.invoiceReceiver.otherBrokerFirm.toString()
                                    : ''
                            }
                            onChange={props.onInvoiceReceiverOtherBrokerFirmChange}
                        >
                            {props.availableOtherToInvoice
                                .filter((x: any) => x.isHeadQuarter)
                                .map((x: any) => (
                                    <option value={x.id} key={x.id}>
                                        {x.name +
                                            ' (' +
                                            Translate('orders/create/form/head-office') +
                                            ')'}{' '}
                                    </option>
                                ))}
                            {props.availableOtherToInvoice
                                .filter((x: any) => !x.isHeadQuarter)
                                .map((x: any) => (
                                    <option value={x.id} key={x.id}>
                                        {x.name}
                                    </option>
                                ))}
                        </FormSelect>
                    </ValidatableFormGroup>
                )}
                {props.invoiceReceiver.receiver === InvoiceReceiverTypes.Seller && (
                    <ValidatableFormGroup
                        required
                        validationKey="invoiceReceiver.InvoiceBillingMethod"
                        errors={props.errors}
                    >
                        <ControlLabel>
                            {Translate(
                                'orders/create/form/input-label/invoice-receiver-communication-type'
                            )}
                        </ControlLabel>
                        <FormSelect
                            name="invoiceReceiver.invoiceBillingMethod"
                            value={
                                props.invoiceReceiver.invoiceBillingMethod
                                    ? props.invoiceReceiver.invoiceBillingMethod.toString()
                                    : ''
                            }
                            onChange={props.onInvoiceBillingMethodChange}
                        >
                            {props.availableInvoiceBillingMethods.length > 1 && (
                                <option key="-1" value="-1">
                                    {Translate(
                                        'orders/create/form/select-invoice-billing-method-placeholder'
                                    )}
                                </option>
                            )}
                            {!props.isCommercial &&
                                props.availableInvoiceBillingMethods.map((x: any) => (
                                    <option value={x.id} key={x.id}>
                                        {Translate(x.name)}
                                    </option>
                                ))}
                        </FormSelect>
                    </ValidatableFormGroup>
                )}

                {!props.isCommercial &&
                    props.invoiceReceiver.receiver === InvoiceReceiverTypes.Seller && (
                        <Row>
                            <Col sm={12} md={8}>
                                <ValidatableFormGroup
                                    required
                                    validationKey="invoiceReceiver.SellerEmail"
                                    errors={props.errors}
                                >
                                    <ControlLabel>
                                        {Translate(
                                            'orders/create/form/input-label/invoice-receiver-seller-email'
                                        )}
                                    </ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="invoiceReceiver.sellerEmail"
                                        value={
                                            props.invoiceReceiver.sellerEmail
                                                ? props.invoiceReceiver.sellerEmail
                                                : ''
                                        }
                                        onChange={props.onDataChange}
                                    />
                                </ValidatableFormGroup>
                            </Col>
                            <Col sm={12} md={4}>
                                <ValidatableFormGroup
                                    required
                                    validationKey="invoiceReceiver.SellerPersonalNumber"
                                    errors={props.errors}
                                >
                                    <ControlLabel>
                                        {Translate(
                                            'orders/create/form/input-label/invoice-receiver-seller-personal-number'
                                        )}
                                    </ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="invoiceReceiver.sellerPersonalNumber"
                                        value={
                                            props.invoiceReceiver.sellerPersonalNumber
                                                ? props.invoiceReceiver.sellerPersonalNumber
                                                : ''
                                        }
                                        inputMode="text"
                                        pattern="[0-9+-]*"
                                        onKeyPress={e => {
                                            const allowed = /[0-9+-]/;
                                            if (!allowed.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        onChange={props.onDataChange}
                                    />
                                </ValidatableFormGroup>
                            </Col>
                        </Row>
                    )}
                {!props.isCommercial &&
                    props.invoiceReceiver.receiver === InvoiceReceiverTypes.Seller && (
                        <ValidatableFormGroup
                            required
                            validationKey="invoiceReceiver.SellerAgreementAccepted"
                            errors={props.errors}
                        >
                            <Checkbox
                                className="required"
                                name="invoiceReceiver.sellerAgreementAccepted"
                                checked={props.invoiceReceiver.sellerAgreementAccepted}
                                onChange={props.onDataChange}
                            >
                                <span>
                                    {Translate(
                                        'orders/create/form/input-label/invoice-receiver-seller-agreement-accepted'
                                    )}
                                </span>
                            </Checkbox>
                            <span
                                className="view-agreement"
                                onClick={() => props.openAgreementModal()}
                            >
                                {Translate('orders/create/form/input-label/view-agreement')}
                            </span>
                        </ValidatableFormGroup>
                    )}
                {props.invoiceReceiver.allowsSeparateBillingAddress && props.isCommercial && (
                    <Checkbox
                        disabled={
                            !props.isPackageOrder &&
                            props.invoiceReceiver.receiver === InvoiceReceiverTypes.Seller
                        }
                        name="invoiceReceiver.separateBillingAddress"
                        checked={props.invoiceReceiver.separateBillingAddress}
                        onChange={props.onDataChange}
                    >
                        <span>
                            {Translate(
                                'orders/create/form/input-label/invoice-receiver-separate-billing-address'
                            )}
                        </span>
                    </Checkbox>
                )}
            </fieldset>
            {(props.invoiceReceiver.separateBillingAddress ||
                (!props.isPackageOrder &&
                    props.invoiceReceiver.receiver === InvoiceReceiverTypes.Seller)) &&
                props.invoiceReceiver.allowsSeparateBillingAddress && (
                    <fieldset>
                        <legend>
                            {Translate(
                                'orders/create/form/input-label/invoice-receiver-separate-billing-address'
                            )}
                        </legend>
                        {!props.isCommercial &&
                            (props.invoiceReceiver.separateBillingAddress ||
                                !props.isPackageOrder) &&
                            props.invoiceReceiver.receiver === InvoiceReceiverTypes.Seller && (
                                <ValidatableFormGroup
                                    required
                                    validationKey="invoiceReceiver.SellerName"
                                    errors={props.errors}
                                >
                                    <ControlLabel>
                                        {Translate(
                                            'orders/create/form/input-label/invoice-receiver-seller-name'
                                        )}
                                    </ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="invoiceReceiver.sellerName"
                                        value={
                                            props.invoiceReceiver.sellerName
                                                ? props.invoiceReceiver.sellerName
                                                : ''
                                        }
                                        onChange={props.onDataChange}
                                    />
                                </ValidatableFormGroup>
                            )}

                        {props.isCommercial &&
                            (props.invoiceReceiver.separateBillingAddress ||
                                !props.isPackageOrder) && (
                                <ValidatableFormGroup
                                    required
                                    validationKey="invoiceReceiver.OrganizationNumber"
                                    errors={props.errors}
                                >
                                    <ControlLabel>
                                        {Translate(
                                            'orders/create/form/input-label/invoice-receiver-organizationNumber'
                                        )}
                                    </ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="invoiceReceiver.organizationNumber"
                                        value={
                                            props.invoiceReceiver.organizationNumber
                                                ? props.invoiceReceiver.organizationNumber
                                                : ''
                                        }
                                        onChange={props.onDataChange}
                                    />
                                </ValidatableFormGroup>
                            )}

                        {props.isCommercial &&
                            (props.invoiceReceiver.separateBillingAddress ||
                                !props.isPackageOrder) && (
                                <ValidatableFormGroup
                                    required
                                    validationKey="invoiceReceiver.LegalName"
                                    errors={props.errors}
                                >
                                    <ControlLabel>
                                        {Translate(
                                            'orders/create/form/input-label/invoice-receiver-legalName'
                                        )}
                                    </ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="invoiceReceiver.legalName"
                                        value={
                                            props.invoiceReceiver.legalName
                                                ? props.invoiceReceiver.legalName
                                                : ''
                                        }
                                        onChange={props.onDataChange}
                                    />
                                </ValidatableFormGroup>
                            )}

                        {props.isCommercial &&
                            (props.invoiceReceiver.separateBillingAddress ||
                                !props.isPackageOrder) && (
                                <ValidatableFormGroup
                                    required
                                    validationKey="invoiceReceiver.Reference"
                                    errors={props.errors}
                                >
                                    <ControlLabel>
                                        {Translate(
                                            'orders/create/form/input-label/invoice-receiver-reference'
                                        )}
                                    </ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="invoiceReceiver.reference"
                                        value={
                                            props.invoiceReceiver.reference
                                                ? props.invoiceReceiver.reference
                                                : ''
                                        }
                                        onChange={props.onDataChange}
                                    />
                                </ValidatableFormGroup>
                            )}

                        {(props.invoiceReceiver.separateBillingAddress || !props.isPackageOrder) &&
                            props.invoiceReceiver.allowsSeparateBillingAddress && (
                                <ValidatableFormGroup
                                    required
                                    validationKey="invoiceReceiver.AddressLine1"
                                    errors={props.errors}
                                >
                                    <ControlLabel>
                                        {Translate(
                                            'orders/create/form/input-label/invoice-receiver-address-line-1'
                                        )}
                                    </ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="invoiceReceiver.addressLine1"
                                        value={
                                            props.invoiceReceiver.addressLine1
                                                ? props.invoiceReceiver.addressLine1
                                                : ''
                                        }
                                        onChange={props.onDataChange}
                                    />
                                </ValidatableFormGroup>
                            )}

                        {(props.invoiceReceiver.separateBillingAddress || !props.isPackageOrder) &&
                            props.invoiceReceiver.allowsSeparateBillingAddress && (
                                <Row>
                                    <Col sm={12} md={4}>
                                        <ValidatableFormGroup
                                            required
                                            validationKey="invoiceReceiver.PostalNumber"
                                            errors={props.errors}
                                        >
                                            <ControlLabel>
                                                {Translate(
                                                    'orders/create/form/input-label/invoice-receiver-postal-number'
                                                )}
                                            </ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="invoiceReceiver.postalNumber"
                                                value={
                                                    props.invoiceReceiver.postalNumber
                                                        ? props.invoiceReceiver.postalNumber.toString()
                                                        : ''
                                                }
                                                onChange={props.onDataChange}
                                            />
                                        </ValidatableFormGroup>
                                    </Col>
                                    <Col sm={12} md={8}>
                                        <ValidatableFormGroup
                                            required
                                            validationKey="invoiceReceiver.City"
                                            errors={props.errors}
                                        >
                                            <ControlLabel>
                                                {Translate(
                                                    'orders/create/form/input-label/invoice-receiver-city'
                                                )}
                                            </ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="invoiceReceiver.city"
                                                value={
                                                    props.invoiceReceiver.city
                                                        ? props.invoiceReceiver.city
                                                        : ''
                                                }
                                                onChange={props.onDataChange}
                                            />
                                        </ValidatableFormGroup>
                                    </Col>
                                </Row>
                            )}
                    </fieldset>
                )}
        </form>
    );
};

export default CreateOrderInvoiceReceiverForm;
